module.exports = __webpack_public_path__ + "static/media/taylor-swift-lose.c32420f7.jpg";